import { Auth } from 'aws-amplify';

// Routes the user through Cognito's Hosted UI via Amplify's OAuth flow.
// Going through Auth.federatedSignIn (rather than constructing the /login URL
// by hand) is required for the upcoming Amplify v6 upgrade: v6 validates a
// `state` parameter on the return trip that only exists if Amplify itself
// initiated the redirect. Staying on this code path on v5 de-risks the bump.
export function redirectUnauthedUser() {
  Auth.federatedSignIn();
}
